import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, Paper, Typography } from "@material-ui/core";
import { Button } from "components/Forms/StyledComponents";

interface Props {
  title: string;
  description: string;
}

export default function Message({ title, description }: Props) {
  const { t } = useTranslation("stats");
  const history = useHistory();

  return (
    <Paper style={{ padding: "24px" }}>
      <Typography variant="h6" gutterBottom>
        {title}
      </Typography>
      <Box mb={2}>
        <Typography color="textSecondary">{description}</Typography>
      </Box>
      <Button
        size="small"
        wording={t("accounts.backToList")}
        onClick={() => history.push("/rules/list")}
      />
    </Paper>
  );
}
